var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.loading)?_vm._t("loading"):_vm._t("layout",null,{"token":_setup.token,"error":_setup.error})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }